import React from 'react';
import { getBaseStationListPath } from 'routing/paths';
// components
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CommonButton from 'components/Buttons/CommonButton';

interface Props {
  stationId: number;
}

export const BaseStationNotFound = ({ stationId }: Props): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      alignContent="space-between"
      justifyContent="center"
      height="80vh"
    >
      <Typography variant="h4">
        Station #{ stationId } not found
      </Typography>

      <CommonButton type="button" label="Back to list" LinkTo={ getBaseStationListPath() } icon={ <ArrowBackIcon/> }/>;
    </Box>
  );
};
